import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './search-bar.scss'
import cn from 'classnames'
import {connect} from "react-redux";
import setSearchUrlHolder from "../../actions/setSearchUrlHolder";
import setHoldKeyword from "../../actions/setHoldKeyword";

class SearchBar extends Component {
  componentDidMount = () => {
    const {
      holdKeyword,
      searchResultsKeyword,
    } = this.props
    const value =  holdKeyword || searchResultsKeyword
    this.field.value =  value === undefined ? '' : value
  }

  handleSearchClick = (e) => {
    const { onClick } = this.props
    onClick(e)
  }

  getKeyword = () => {
    const {
      holdKeyword,
      searchResultsKeyword,
    } = this.props
    return  holdKeyword || searchResultsKeyword
  }

  render() {
    const {
      title,
      onChange,
      onKeyPress,
      showSearchBox,
      holdKeyword,
      searchResultsKeyword,
    } = this.props
    return (
      <div className={cn('desktop-search-bar', (showSearchBox || holdKeyword || searchResultsKeyword)  && 'focus')}
           onClick={this.handleSearchClick}
      >
        <div className="desktop-search-bar__search-icon">
          <svg aria-labelledby="NEWSEARCH">
            <use xlinkHref="#NEWSEARCH" />
          </svg>
        </div>

        {(showSearchBox || holdKeyword || searchResultsKeyword) && (
          <label className="desktop-search-bar__header">
            <div className="desktop-search-bar__header-title">
              {title}
            </div>
          </label>
        )}

        <div className="desktop-search-bar__input">
          <input
            className="desktop-search-bar__input-field"
            type="text"
            name="keyword"
            onChange={onChange}
            onKeyPress={onKeyPress}
            ref={field => this.field = field}
            value={holdKeyword}
            placeholder={title}
            autoComplete="off"
          />
        </div>
      </div>
    )
  }
}

SearchBar.propTypes = {
  title: PropTypes.string.isRequired,
  onCloseBar: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
}

const mapStateToProps = ({
  main: {
    holdKeyword,
    searchUrlHolder,
    searchResultsKeyword,
    homePageVideoBanner,
  },
  browser,
  globalLoader: {
    isShow,
  },
}) => ({
  holdKeyword,
  searchUrlHolder,
  browser,
  homePageVideoBanner,
  searchResultsKeyword,
  globalLoading: isShow,
})

const mapDispatchToProps = {
  setSearchUrlHolderAction: setSearchUrlHolder,
  setHoldKeywordAction: setHoldKeyword,
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar)

